module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAKxJREFUeNpiYBgFwx0wkqtRSlzaHo/0h2cvn17Ep5+FAkcfwCP3AIgVaWUxCCyAYgwfE9LIQuWouwAM4o/EKGSi0KIEaJDDcAGxGqkd1BfoZfEDYNAeJEcj00Dl41GLRy0etXjUYvpZDGwA6BMjRgsfTwBaFI9k6XwgFUCvoIbVSAXQqpEucVyA1MIQgFaFE+jS2IPG6QFo28qB2FYHVQDIciDmH22oD3oAEGAA4OQlkrXo+bYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/images/vent/3.png
// module id = 758
// module chunks = 0